export default __webpack_public_path__ + "static/media/canvasAndFramedLargeFramedWood.34ed2d0c.jpg";